// extracted by mini-css-extract-plugin
export var image = "ServerImage-module--image--y9BBV";
export var imageWrapper = "ServerImage-module--imageWrapper--5Vm2M";
export var placeholder = "ServerImage-module--placeholder--HN273";